export const enum enquiryConstants {
    createEnquiryRequest = "CREATE_ENQUIRY_REQUEST",
    createEnquirySuccess = "CREATE_ENQUIRY_SUCCESS",
    createEnquiryFailure = "CREATE_ENQUIRY_FAILURE",
    
    listEnquiryRequest = "LIST_ENQUIRY_REQUEST",
    listEnquirySuccess = "LIST_ENQUIRY_SUCCESS",
    listEnquiryFailure = "LIST_ENQUIRY_FAILURE",
    
    deleteEnquiryRequest = "DELETE_ENQUIRY_REQUEST",
    deleteEnquirySuccess = "DELETE_ENQUIRY_SUCCESS",
    deleteEnquiryFailure = "DELETE_ENQUIRY_FAILURE",

    viewEnquiryRequest = "VIEW_ENQUIRY_REQUEST",
    viewEnquirySuccess = "VIEW_ENQUIRY_SUCCESS",
    viewEnquiryFailure = "VIEW_ENQUIRY_FAILURE",

    updateEnquiryRequest = "UPDATE_ENQUIRY_REQUEST",
    updateEnquirySuccess = "UPDATE_ENQUIRY_SUCCESS",
    updateEnquiryFailure = "UPDATE_ENQUIRY_FAILURE",

    clearViewEnquiry = "CLEAR_VIEW_ENQUIRY",
}